import { Account } from "..";

/**
 * Where a link to a removed sign-up step should land instead, or null when
 * the step still exists. Old bookmarks and drafts can still point at them.
 */
export const replacedPage = (
  page: string,
  account: Pick<Account, "userType">,
): string | null => {
  // The personal info step (EV ownership, subscriptions) was removed.
  if (page === "personalInfoForm") {
    return account.userType === "user" ? "userReviewForm" : "businessInfoForm";
  }
  return null;
};
